import styled from 'styled-components';
import BGColor from './BGColor'

const Tag = styled.span`
  padding: 3px 6px;
  font-size: 12px;
  ${props => BGColor(props.color)};
  border-radius: 2px;
`

export default Tag;


// WEBPACK FOOTER //
// ./client/components/Styled/Tag/index.js